import { Component } from '@builder.io/sdk';

export const config: Component = {
    name: 'RichText',
    inputs: [
        {
            name: 'fontFamily',
            type: 'string',
            enum: ['inter', 'polysans'],
            defaultValue: 'polysans',
            helperText: 'Available font family',
        },
        {
            name: 'content',
            type: 'richText',
            defaultValue: '<p>Write your <strong>text</strong> here</p>',
            required: true,
        },
    ],
};
